"use client";

import Link from "next/link";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { BlogArticle } from "@/app/types/BlogArticle";
import { getCategoryLabelKey } from "../BlogCategories/BlogCategories.logic";
import styles from "./BlogArticleCard.module.css";
import { getArticleLocale } from "./BlogArticles.logic";

type Props = {
  article: BlogArticle;
  lang: string;
};

export default function BlogArticleCard(props: Props) {
  const T = useT();
  const { article, lang } = props;
  const categoryKey = getCategoryLabelKey(article.categoryId);
  const locale = getArticleLocale(article, lang);

  return (
    <Link href={`/${lang}/blog/${article.slug[lang]}`} className={styles.card}>
      <div className={styles.header}>
        <div className={styles.meta}>
          {categoryKey && (
            <>
              <span>{T(categoryKey)}</span>
              <span className={styles.metaDot}>·</span>
            </>
          )}
          <span>{article.readTime} min</span>
        </div>
        <h2 className={styles.title}>{locale.title}</h2>
      </div>

      <div className={styles.body}>
        <p className={styles.excerpt}>{locale.excerpt}</p>
        <span className={styles.readMore}>
          {T(TKey.BLOG_READ_ARTICLE)}
          <span className={styles.arrow}>→</span>
        </span>
      </div>
    </Link>
  );
}
